import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { map } from 'rxjs/operators';
import { getAuthAccountDetails } from '@aaa/emember/store-membership';
import { isFlagEnabled } from '../../../store/feature-flags';
import { FeatureName } from '../../../store/feature-flags/types';

export const redirectToRenewIfBalanceDue: CanActivateChildFn = () => {
  const store = inject(Store<AppStore>);
  const router = inject(Router);
  const renewRoute = ['account', 'membership', 'renew'];

  return store.select(getAuthAccountDetails).pipe(
    map((accountDetails) => {
      const hasPositiveBalance =
        accountDetails?.balance !== null && accountDetails?.balance !== undefined && accountDetails.balance > 0;

      if (isFlagEnabled(FeatureName.BALANCE_DUE_RENEW_REDIRECT) && hasPositiveBalance) {
        router.navigate(renewRoute);
        return false;
      }

      return true;
    }),
  );
};

export default redirectToRenewIfBalanceDue;
